module.exports = __webpack_public_path__ + "static/media/ceramic-grey.56ebbb13.jpg";